import Label from './Label.js';

export default Label;
